import { DocusignTemplatesTableFields } from './enums'

export const docusignTemplateTableHeaderTitles: Record<DocusignTemplatesTableFields, string> = {
  [DocusignTemplatesTableFields.title]: 'Title',
  [DocusignTemplatesTableFields.description]: 'Description',
  [DocusignTemplatesTableFields.docusignTemplateId]: 'DocuSign ID',
  [DocusignTemplatesTableFields.createdAt]: 'Date created',
  // The actions column is icon-and-button only; a header would just add noise.
  [DocusignTemplatesTableFields.actions]: '',
}

// A per-customer list of a handful of rows, so this stops at 100 — same reasoning as markets.
// The customers list carries 500/1000 only because of an explicit product request.
export const docusignTemplatePageSizeOptions = [25, 50, 100]

export const DOCUSIGN_TEMPLATES_GRID_COLUMNS_STORAGE_KEY = 'admin.docusignTemplates.gridColumns'
